<template>
  <div class="verify-result">
    <iconpark-icon
      v-if="
        result?.status === USER_VERIFY_STATUS.SUCCESS ||
        result?.status === USER_VERIFY_STATUS.WAIT
      "
      name="pay-succ"
      size="50"
      class="text-success"
    ></iconpark-icon>
    <div class="title">
      <span v-if="result?.status === USER_VERIFY_STATUS.SUCCESS">
        {{ $t('ren-zheng-cheng-gong') }}
      </span>
      <div
        v-if="result?.status === USER_VERIFY_STATUS.FAIL"
        class="flex-y-center gap-[10px]"
      >
        <iconpark-icon
          name="close-fill"
          size="34"
          class="text-error"
        ></iconpark-icon>
        <span> {{ $t('ren-zheng-shi-bai') }} </span>
      </div>
    </div>
    <template v-if="result?.status === USER_VERIFY_STATUS.WAIT">
      <div class="title">
        <span> {{ $t('ti-jiao-cheng-gong-shen-he-zhong') }} </span>
      </div>
      <div class="desc">
        {{
          $t(
            'wo-men-hui-zai-3-ge-gong-zuo-ri-nei-chu-li-wan-cheng-nin-de-shen-qing-qing-liu-yi-ping-tai-he-duan-xin-tong-zhi'
          )
        }}
      </div>
    </template>
    <template v-if="result?.status === USER_VERIFY_STATUS.FAIL">
      <div class="desc">
        {{
          $t(
            'bao-qian-nin-de-shou-quan-shen-qing-shen-he-shi-bai-ju-ti-yuan-yin-ru-xia'
          )
        }}
      </div>
      <Reason
        class="bg-back-4 p-[10px_50px] max-w-[595px] mt-[28px] rounded-[12px]"
        :reason="result.reject_reason"
      />
    </template>

    <div class="flex gap-[20px] mt-[66px] justify-center">
      <a-button
        type="primary"
        size="large"
        class="w-[162px]"
        @click="emits('set', 0)"
      >
        {{
          result?.status === USER_VERIFY_STATUS.SUCCESS ||
          result?.status === USER_VERIFY_STATUS.WAIT
            ? $t('cha-kan-shen-qing')
            : $t('zhong-xin-ren-zheng')
        }}
      </a-button>
      <a-button
        type="primary"
        size="large"
        class="w-[162px] yy-btn"
        @click="
          () =>
            showContact(
              result?.status === USER_VERIFY_STATUS.SUCCESS
                ? 'yygw-rzcg-llwm'
                : 'yygw-rzsb-llwm'
            )
        "
      >
        {{ $t('lian-xi-wo-men') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Reason from './reason.vue'
import type { UserVerifyInfo } from '~/api/interface'
import { USER_VERIFY_STATUS } from '~/constants'
import { showContact } from '~/hooks/useModal/modals/contact'

const props = defineProps<{
  data?: UserVerifyInfo
}>()

const result = computed(() => props.data?.identify_info)

const emits = defineEmits(['set'])
</script>

<style lang="scss" scoped>
.verify-result {
  @apply bg-back-2 rounded-[18px] py-[100px] mt-[56px] flex flex-col justify-center  items-center;
  .title {
    @apply text-[28px] text-font-1 font-medium text-center mt-[20px] flex-y-center gap-[8px];
  }
  .desc {
    @apply text-16 text-font-80 text-center  mt-[20px];
  }
}
</style>
